export default __webpack_public_path__ + "static/media/tigerbox_touch_light_blue.4b14f5a0.png";